import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { MapContainer, MapContainerProps } from 'react-leaflet';

import { BaseMapLayer } from './BaseMapLayer';
import { ControlFlow } from './ControlFlow';
import { GISPortalLayer, FeatureLayerConfig } from './GISPortalLayer';
import { Cfg } from './useGISFetcher';

import 'leaflet/dist/leaflet.css';
import './MapControl.scss';

export type MapControlProps<Details> = {
  onChange: (value: Details) => void;
  token?: string;
  layers: FeatureLayerConfig[];
} & Pick<MapContainerProps, 'center' | 'zoom' | 'minZoom' | 'maxZoom'> &
  Pick<Cfg, 'onErr'>;

export const MapControl = React.memo<MapControlProps<any>>(function ({
  layers,
  center,
  zoom,
  minZoom,
  maxZoom,
  token,
  onChange,
  onErr,
}) {
  if (isEmpty(layers)) {
    return <>no layer could be visualized</>;
  }

  return (
    <div className="map-control">
      <MapContainer center={center} zoom={zoom} maxZoom={maxZoom} minZoom={minZoom} className="map-container">
        <ControlFlow center={center} zoom={zoom} />
        <BaseMapLayer token={token} />
        {layers.map((config: FeatureLayerConfig) => (
          <GISPortalLayer key={config.url} token={token} config={config} onSelect={onChange} onErr={onErr} />
        ))}
      </MapContainer>
    </div>
  );
});
